import React from 'react'
import { Button } from 'antd'
import { ButtonProps } from 'antd/lib/button/button'
import cl from 'classnames'

import Icon, { IconType } from 'Shared/atoms/Icon'

import styles from './styles.module.scss'

type IconButtonProps = ButtonProps & {
	iconType: IconType
	iconClassName?: string
}

const IconButton: React.FC<IconButtonProps> = ({
	className,
	iconType,
	icon,
	iconClassName,
	...props
}) => {
	const iconComponent = iconType ? (
		<Icon type={iconType} className={cl(styles.icon, iconClassName)} />
	) : icon ? (
		icon
	) : null

	return <Button {...props} className={cl(styles.button, className)} icon={iconComponent} />
}

export default IconButton
